import React from 'react';
import {EdgeProps} from 'reactflow';

import BaseEdgeRenderer from 'ui-library/reactflow/edges/BaseEdgeRenderer';

import {getEdgeStatus} from './edgeUtils';

export default function TaskSchemaControlFlowEdge(props: EdgeProps): JSX.Element {
  return <BaseEdgeRenderer {...props} data={{...props.data, status: getEdgeStatus(props)}} />;
}
